/* eslint-disable no-param-reassign */
// eslint-disable-next-line import/no-extraneous-dependencies
import { produce } from 'immer';
import { quickViewSectionViewed } from '../../../analytics';

export default (set, get, title) => set(produce(get(), (draft) => {
  if (!draft.digitalData) {
    draft.digitalData = { event: [] };
  }

  const trackQuickViewSectionViewed = { title };

  draft.digitalData.quickViewSectionViewed = trackQuickViewSectionViewed;

  quickViewSectionViewed(trackQuickViewSectionViewed);
}), false, { type: 'TRACK_QUICK_VIEW_SECTION_VIEWED' });
